var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_4060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5583 1.84749L17.6417 5.80583C17.8496 5.90964 18.0245 6.06936 18.1467 6.26705C18.2688 6.46475 18.3335 6.69259 18.3333 6.925V8.125C18.3333 8.7 17.8667 9.16666 17.2917 9.16666H16.6667V15.8333H17.5C17.721 15.8333 17.933 15.9211 18.0893 16.0774C18.2455 16.2337 18.3333 16.4456 18.3333 16.6667C18.3333 16.8877 18.2455 17.0996 18.0893 17.2559C17.933 17.4122 17.721 17.5 17.5 17.5H2.5C2.27899 17.5 2.06703 17.4122 1.91075 17.2559C1.75447 17.0996 1.66667 16.8877 1.66667 16.6667C1.66667 16.4456 1.75447 16.2337 1.91075 16.0774C2.06703 15.9211 2.27899 15.8333 2.5 15.8333H3.33334V9.16666H2.70834C2.13334 9.16666 1.66667 8.7 1.66667 8.125V6.925C1.66667 6.49 1.89167 6.08999 2.25501 5.86333L9.44084 1.84749C9.61445 1.76066 9.80589 1.71545 10 1.71545C10.1941 1.71545 10.3847 1.76066 10.5583 1.84749ZM15 9.16666H5V15.8333H7.5V10.8333H9.16667V15.8333H10.8333V10.8333H12.5V15.8333H15V9.16666ZM10 3.43166L3.33334 7.18166V7.5H16.6667V7.18166L10 3.43166ZM10 4.99999C10.221 4.99999 10.433 5.08779 10.5893 5.24407C10.7455 5.40035 10.8333 5.61231 10.8333 5.83333C10.8333 6.05434 10.7455 6.2663 10.5893 6.42258C10.433 6.57886 10.221 6.66666 10 6.66666C9.77899 6.66666 9.56703 6.57886 9.41075 6.42258C9.25447 6.2663 9.16667 6.05434 9.16667 5.83333C9.16667 5.61231 9.25447 5.40035 9.41075 5.24407C9.56703 5.08779 9.77899 4.99999 10 4.99999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_4060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.ec7f5261c52142bd7e668baf0e3d4283.svg";
export { ForwardRef as ReactComponent };